import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

import * as API from "../api/api.js";

const DrivingLocation = () => {
  const [loading, setLoading] = useState(false);
  const [miami, setMiami] = useState(null);
  const [broward, setBroward] = useState(null);
  const [palmBeach, setPlamBeach] = useState(null);
  const [florida, setFlorida] = useState(null);

  useEffect(() => {
    setMiamiDatas();
    setBrowardDatas();
    setPalmDatas();
    setFloridaDatas();
  }, []);

  const setMiamiDatas = (index) => {
    setLoading(true);
    API.getDatas("city/miami-dade")
      .then((res) => {
        findLocations(res.data, 'miami-dade', setMiami);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const setBrowardDatas = () => {
    setLoading(true);
    API.getDatas("city/broward")
      .then((res) => {
        findLocations(res.data, 'broward', setBroward);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const setPalmDatas = () => {
    setLoading(true);
    API.getDatas("/city/palm-beach")
      .then((res) => {
        findLocations(res.data, 'palm-beach', setPlamBeach);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const setFloridaDatas = () => {
    setLoading(true);
    API.getDatas("city/central-florida")
      .then((res) => {
        findLocations(res.data, 'central-florida', setFlorida);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const findLocations = (response, slug, stateObj) => {
    const lIndex = response.findIndex(f => f.slug === slug);
    if (lIndex != -1) {
      stateObj(response[lIndex].locations);
    }
  }

  return (
    <>
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
        <div className="accordion location-accordion" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header border-bottom" id="headingOne">
              <button
                className="accordion-button"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                Miami Dade County
              </button>
            </h2>
            <div
              id="collapseOne"
              className="accordion-collapse collapse show"
              aria-labelledby="headingOne"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="row">
                  {!loading &&
                    miami &&
                    miami.map((miamiData) => (
                      <div
                        key={miamiData.title}
                        className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-4 mb-md-5 d-flex justify-content-between flex-column"
                      >
                        <div className="address">
                          <h3>{miamiData.title}</h3>
                          <div className="address-detail mb-3">
                            {miamiData.address.split(',')[0]}<br/>
                            {`${miamiData.address.split(',')[1]}, ${miamiData.address.split(',')[2]}`}
                            <br />
                            <a href="tel: 305-513-0063">
                              Phone: &nbsp;{miamiData.phone}
                            </a>
                            <br />
                            Fax: &nbsp;{miamiData.fax} <br />
                          </div>
                        </div>
                        <div className="location-btns">
                          <Link to="/contact-us" className="btn contact-us-btn contact-btn mb-3">
                            <i className="fa-solid fa-envelope contact"></i>
                            Contact Us
                          </Link>
                          <Link
                            to={`/location/${miamiData.slug}`}
                            className="btn contact-us-btn  contact-btn location-btn  mb-3"
                          >
                            <i className="fa-solid fa-location-dot"></i>{" "}
                            Locations
                          </Link>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header border-bottom" id="headingTwo">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                Broward County
              </button>
            </h2>
            <div
              id="collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="headingTwo"
              data-bs-parent="#accordionExample"
            >
              <div className="accordion-body">
                <div className="row">
                  {!loading &&
                    broward &&
                    broward.map((browardData, bIndex) => (
                      <div
                        key={bIndex}
                        className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-4 mb-md-5 d-flex justify-content-between flex-column"
                      >
                        <div className="address">
                          <h3>{browardData.title}</h3>
                          <div className="address-detail mb-3">
                          {browardData.address.split(',')[0]}<br/>
                            {`${browardData.address.split(',')[1]}, ${browardData.address.split(',')[2]}`}
                            <br />
                            <a href="tel:954 422-5757">
                              Phone: &nbsp;{browardData.phone}
                              <br />
                            </a>
                            Fax: &nbsp;{browardData.fax} <br />
                          </div>
                        </div>
                        <div className="location-btns">
                          <Link to="/contact-us" className="btn contact-us-btn contact-btn mb-3">
                            <i className="fa-solid fa-envelope contact"></i>
                            Contact Us
                          </Link>
                          <Link
                            to={`/location/${browardData.slug}`}
                            className="btn contact-us-btn  contact-btn location-btn  mb-3"
                          >
                            <i className="fa-solid fa-location-dot"></i>{" "}
                            Locations
                          </Link>
                        </div>
                      </div>
                    ))}
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header border-bottom" id="headingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  Palm Beach County
                </button>
              </h2>
              <div
                id="collapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <div className="row">
                    {palmBeach &&
                      palmBeach.map((palmData, pIndex) => (
                        <div
                          key={pIndex}
                          className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-4 mb-md-5  d-flex justify-content-between flex-column"
                        >
                          <div className="address">
                            <h3>{palmData.title}</h3>
                            <div className="address-detail mb-3">
                              {palmData.address.split(',')[0]}<br/>
                              {`${palmData.address.split(',')[1]}, ${palmData.address.split(',')[2]}`} <br />
                              <a href="tel:(561) 963-7555 ">
                                phone: &nbsp;{palmData.phone} <br />
                              </a>
                              Fax: &nbsp;{palmData.fax}
                              <br />
                            </div>
                          </div>
                          <div className="location-btns">
                            <Link to="/contact-us" className="btn contact-us-btn contact-btn mb-3">
                              <i className="fa-solid fa-envelope contact"></i>
                              Contact Us
                            </Link>
                            <Link
                              to={`/location/${palmData.slug}`}
                              className="btn contact-us-btn  contact-btn location-btn  mb-3"
                            >
                              <i className="fa-solid fa-location-dot"></i>{" "}
                              Locations
                            </Link>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header " id="headingfour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapsefour"
                  aria-expanded="false"
                  aria-controls="collapsefour"
                >
                  Central Florida
                </button>
              </h2>
              <div
                id="collapsefour"
                className="accordion-collapse collapse"
                aria-labelledby="headingfour"
                data-bs-parent="#accordionExample"
              >
                <div className="accordion-body">
                  <div className="row">
                    {florida &&
                      florida.map((centralData, cIndex) => (
                        <div
                          key={cIndex}
                          className="col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-4 mb-md-5 d-flex justify-content-between flex-column"
                        >
                          <div className="address">
                            <h3>{centralData.title}</h3>
                            <div className="address-detail mb-3">
                              {centralData.address.split(',')[0]},<br/>
                                {`${centralData.address.split(',')[1]}, ${centralData.address.split(',')[2]}`}
                              <br />
                              <a href="tel:407-502-0099 ">
                                Phone: &nbsp;{centralData.phone} <br />
                              </a>
                              fax: &nbsp;{centralData.fax}
                              <br />
                            </div>
                          </div>
                          <div className="location-btns">
                            <Link to="/contact-us" className="btn contact-us-btn contact-btn mb-3">
                              <i className="fa-solid fa-envelope contact"></i>
                              Contact Us
                            </Link>
                            <Link to={`/location/${centralData.slug}`} className="btn contact-us-btn  contact-btn location-btn  mb-3">
                              <i className="fa-solid fa-location-dot"></i>{" "}
                              Locations
                            </Link>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DrivingLocation;
